import { render, staticRenderFns } from "./HSideBar.vue?vue&type=template&id=20af477c&scoped=true&"
import script from "./HSideBar.vue?vue&type=script&lang=ts&"
export * from "./HSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./HSideBar.vue?vue&type=style&index=0&id=20af477c&lans=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af477c",
  null
  
)

export default component.exports